/* eslint-disable no-console */
const { jQuery: $ } = window;
class Site {
	constructor() {
		this.initMobileNav();
	}

	initMobileNav() {
		this.mobileNav = $( '#mobile-nav' );
		this.mobileNavEnabled = ! this.mobileNav.hasClass( '!hidden' );

		$( '#mobile-nav-button' ).on( 'click', () => {
			this.mobileNav.removeClass( '!hidden' );
			this.mobileNavEnabled = true;
		} );

		$( '#mobile-nav-close' ).on( 'click', () => this.mobileNavClose() );

		$( document ).on( 'keyup', ( e ) => {
			if ( this.mobileNavEnabled && e.which === 27 ) {
				this.mobileNavClose();
			}
		} );
	}

	mobileNavClose() {
		this.mobileNav.addClass( '!hidden' );
		this.mobileNavEnabled = false;
	}
}

new Site();
